module.exports = __webpack_public_path__ + "static/media/event-setup-1.d89870ab.jpg";